import React, { useEffect, useState } from 'react';
import "./loader.scss";

const LoaderPage: React.FC = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loader-container">
      <div className="loader-process" style={{ width: `${progress}%` }}>
      </div>
    </div>
  );
};

export default LoaderPage;
